import type { FC } from "react";
import React from "react";
import { Body, Box } from "@edreamsodigeo/prisma-design-system";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import styles from "./styles";
import type { CategorySectionProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxBenefits/types";

const CategorySectionMobile: FC<CategorySectionProps> = ({
  category,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Box pb={"base"}>
      <Body
        type={"xxSmall"}
        weight={"medium"}
        color={"neutral.80"}
        sx={styles.category}
      >
        {t(category) || category}
      </Body>
      {children}
    </Box>
  );
};

export default CategorySectionMobile;
